import {
    Component,
    HostBinding,
    OnDestroy,
    OnInit,
    Renderer2
} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {AppService} from '@services/app.service';
import { ActivatedRoute } from '@angular/router';
import { IdentityService } from '../../services/identity.service';

@Component({
    selector: 'app-recover-password',
    templateUrl: './recover-password.component.html',
    styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit, OnDestroy {
    @HostBinding('class') class = 'login-box';

    public recoverPasswordForm: UntypedFormGroup;
    public isAuthLoading = false;
  codeandemail: any;
    constructor(
        private renderer: Renderer2,
        private toastr: ToastrService,
      private appService: AppService,
      private activeRoute: ActivatedRoute,
     private identityService: IdentityService
    ) {}

  ngOnInit(): void {
    this.renderer.addClass(
      document.querySelector('app-root'),
      'login-page'
    );
    this.recoverPasswordForm = new UntypedFormGroup({
      password: new UntypedFormControl(null, Validators.required),
      confirmPassword: new UntypedFormControl(null, Validators.required)
    });

    this.activeRoute.queryParams
      .subscribe(params => {

        this.identityService.getuserwithguid(params.code).subscribe(res => {
          this.codeandemail = res;
        });
      });
  }

    recoverPassword() {
      if (this.recoverPasswordForm.valid) {

        this.identityService.resetPassword({ guid: this.codeandemail.guid, email: this.codeandemail.email, password: this.recoverPasswordForm.get("password")?.value }).subscribe(res => {
          this.toastr.success('Başarılı!', 'Parolanız değişmiştir. Uygulama üzerinen giriş yapabilirsiniz.');
        });


        } else {
            this.toastr.error('Hata!', 'Lütfen info@linguwa.com adresine mail atın!');
        }
    }

    ngOnDestroy(): void {
        this.renderer.removeClass(
            document.querySelector('app-root'),
            'login-page'
        );
    }
}
